// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@awc/MobiusOverrides/LazyImage";
import { productGridCardStyles } from "@awc/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, sharedBadgeStyle } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productGridCardStyles.productListCompareAddToListWrapper = {
    wrapper: {
        css: css`
            flex-direction: row;
            justify-content: space-between;
        `,
    },
    compareCheckbox: {
        css: css`
            padding-top: 0;
        `,
    },
};

productGridCardStyles.badgeContainer = {
    ...mergeWithCss(sharedBadgeStyle.badgeContainer, {
        css: css`
            &&&& {
                ${LazyImageStyle} {
                    margin-top: 4px;
                }
            }
        `,
    }),
};

productGridCardStyles.productListProductImage = {
    customProductBadge: {
        textBadgeWrapperCss: {
            ...mergeWithCss(sharedBadgeStyle.badge, {
                css: css`
                    justify-content: flex-start;
                    width: max-content;
                    max-width: 100%;
                `,
            }),
        },
        textBadgeCss: {
            ...mergeWithCss(sharedBadgeStyle.badgeText, {
                css: css`
                    ${ellipsis(1)}
                `,
            }),
        },
    },
};
